import useThumbnailService from './useThumbnailService';

export { useThumbnailService };
